if (!customElements.get('swk-banner-slider')) {
  customElements.define(
    'swk-banner-slider',
    class SwkBannerSlider extends HTMLElement {
      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        this.destroySwiper();
      }

      initSwiper() {
        if (this.swiper) return;

        const swiperEl = this.querySelector('.swk-banner-slider__swiper');
        if (!swiperEl) return;

        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        if (slideCount <= 1) {
          this.classList.add('swk-banner-slider--single');
          this.style.setProperty('--slide-width', '100%');
          return;
        }

        this.classList.remove('swk-banner-slider--single');

        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
          return;
        }

        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const slideWidth = this.dataset.slideWidth || '85';
        const spaceBetween = parseFloat(this.dataset.spaceBetween || '1.6') * rem;
        const loop = this.dataset.loop === 'true';
        const slidesPerView = this.dataset.slidesPerView || 'auto';

        this.style.setProperty('--slide-width', `${slideWidth}%`);

        this.swiper = new Swiper(swiperEl, {
          slidesPerView,
          spaceBetween,
          loop,
          speed: 600,
        });
      }

      destroySwiper() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
